import TableNavigate from "./TableNavigate"

export default {
    mixins: [TableNavigate],

    data: function () {
        return {
            params: {paginate: 15},
            showModal: null,
            searching: false,
        }
    },

    watch: {
        'params.scout': function () {
            this.searching = true
            this.scout()
        },
    },

    methods: {
        scout: _.debounce(async function () {
            this.search().then(() => this.searching = false)
        }, 500)
    }
}
